<template>
    <div>
        <div v-if="$route.params.id" class="title">Update User</div>
        <div v-else class="title">New User (add new user)</div>
        <v-card
            class="card-container"
            elevation="5"
        >
            <v-card-title>
                User Form
            </v-card-title>
            <v-text-field
                v-model="username"
                label="Username"
                class="form-field"
                required
            />

            <v-text-field
                v-model="password"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show ? 'text' : 'password'"
                label="Password"
                hint="Max 18 characters"
                value=""
                class="form-field"
                required
                @click:append="show = !show"
            />

            <v-switch
                v-model="active"
                class="form-field"
                :label="`Active : ${active.toString()}`"
            />

            <v-select
                v-model="rolesSelected"
                :items="roles"
                attach
                chips
                item-text="role"
                item-value="id"
                label="Roles"
                class="form-field"
            />

            <v-select
                v-model="privilegesSelected"
                :items="privileges"
                attach
                chips
                item-text="privilege"
                item-value="id"
                label="Privileges"
                class="form-field"
                multiple
            />
            <v-select
                v-model="adminSelected"
                :items="admins"
                attach
                chips
                item-text="username"
                item-value="id"
                class="form-field"
                :menu-props="{ top: true, offsetY: true }"
                label="Admin"
            />
            <div class="text-center">
                <v-btn v-if="$route.params.id" class="edit-btn" @click="updateUser">
                    Update User
                </v-btn>
                <v-btn v-else class="edit-btn" @click="createNewUser">
                    Create User
                </v-btn>
            </div>

        </v-card>
        <alert v-if="showAlert" :show-alert="showAlert" :message="message" :type="type" />
    </div>
</template>

<script>
    import privilegesService from '@/services/privileges-service'
    import Alert from '@/components/Alert'
    import rolesService from '@/services/roles-service'
    import userService from '@/services/user-service'
    export default {
        components: { Alert },
        data() {
            return {
                user: {},
                username: '',
                showAlert: false,
                password: '',
                adminSelected: null,
                admins: [],
                roles: [],
                privileges: [],
                rolesSelected: '',
                privilegesSelected: [],
                active: false,
                show: false
            }
        },
        computed: {
            getCurrentUser() {
                return this.$store.getters.getCurrentUser
            }
        },
        watch: {
            showAlert: {
                handler(newval, oldval) {
                    if (newval !== oldval) {
                        setTimeout(() => { this.showAlert = false }, 3000)
                    }
                }
            }
        },
        created() {
            if (this.$route.params.id) {
                this.fetchUserById(this.$route.params.id)
            }
            this.fetchRolesPrivilegesAndAdmins()
        },
        methods: {
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
            },
            fetchRolesPrivilegesAndAdmins() {
                privilegesService.getPrivileges().then(resp => {
                    this.privileges = resp.data.content
                })
                rolesService.getRoles().then(resp => {
                    this.roles = resp.data.content
                })
                userService.getUsers().then(resp => {
                    resp.data.content.forEach(obj => {
                        if (obj.role.role === 'ROLE_ADMIN') {
                            this.admins.push(obj)
                        }
                    })
                })
            },
            fetchUserById(id) {
                userService.getUserById(id).then(resp => {
                    this.user = resp.data
                    this.username = this.user.username
                    this.password = this.user.password
                    this.rolesSelected = this.user.role.id
                    this.active = this.user.active
                    this.adminSelected = this.user.parent ? this.user.parent.id : null
                    this.user.privileges.forEach(obj => {
                        this.privilegesSelected.push(obj.id)
                    }).catch((error) => {
                        this.$emit('set-alert', error.response.data.message, 'error')
                    })
                })
            },
            createNewUser() {
                const user = {
                    username: this.username,
                    password: this.password,
                    active: this.active,
                    parent: this.adminSelected ? { id: this.adminSelected } : null,
                    role: {
                        id: this.rolesSelected
                    },
                    privileges: this.privilegesSelected.map(objId => ({ id: objId }))
                }
                userService.createNewUser(user).then(resp => {
                    this.setAlert('User Created', 'success')
                    setTimeout(() => {
                        this.$router.push('/users')
                    }, 1000)
                }).catch(error => {
                    this.error = error.response.data.code
                    this.message = error.response.data.message
                    this.setAlert(this.message, 'error')
                })
            },
            updateUser() {
                const user = {
                    username: this.username,
                    password: this.password,
                    active: this.active,
                    parent: this.adminSelected ? { id: this.adminSelected } : null,
                    role: {
                        id: this.rolesSelected
                    },
                    privileges: this.privilegesSelected.map(objId => ({ id: objId }))
                }
                userService.updateUser(user, this.$route.params.id).then(resp => {
                    this.setAlert('User Updated', 'success')
                    setTimeout(() => {
                        this.$router.push('/users')
                    }, 1000)
                }).catch(error => {
                    this.error = error.response.data.code
                    this.message = error.response.data.message
                    this.setAlert(this.message, 'error')
                })
            }
        }
    }
</script>

<style scoped>

.title {
    font-size: 1.5rem !important;
    margin-bottom: 10px;
}

.edit-btn {
    text-transform: none !important;
    background: #00acd6 !important;
    color: white;
    margin: 15px;
    width: 90%;
}

.form-field {
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
}

</style>
